import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HostListener } from '@angular/core';

import { MetaDataService, TradeType, JobType } from '../services/meta-data.service';
import { JobDataService } from '../services/job-data.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';

import { environment } from '../../environments/environment';

import { Clients, QuestionTypes, TradeTypes } from '../services/globals.service';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { PostcodeManagerService } from '../services/postcode-manager.service';
import { RouterService } from '../services/router.service';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'HomeServices-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css']
})
export class StartComponent implements OnInit {

  public pageContentParams = {
  };

  public faSpinner = faSpinner;

  public bundlingEnabled: boolean = environment.bundlingEnabled;

  public metaData: MetaDataService = null;

  public url: string = '';
  public router: Router = null;
  public route: ActivatedRoute = null;
  public jobDataService: JobDataService = null;
  public toastr: ToastrService = null;
  public db: AngularFirestore = null;
  public clients: Clients = null;

  public coverageAreaText: string = environment.coverageAreaText;

  public clientID: number = 0;

  public questionTypes: QuestionTypes = null;

  public showPostcodeCheck: boolean = false;
  public showAreaNotCovered: boolean = false;
  public showServicesList: boolean = false;
  public showEmergencyPopup: boolean = false;
  public showMemberShipCheck: boolean = false;

  public emailSubmitLoading: boolean = false;
  public metaDataLoading: boolean = false;

  public trade: TradeType = null;
  public postcode: string = '';
  public email: string = '';
  public serviceAreaEmail: string = '';

  public jobTypeSelectors: Array<JobTypeSelector> = [];

  public showConfirmPopup: boolean = false;
  public confirmPopupContent: string = '';
  public confirmPopupJobTypeSelector: JobTypeSelector;

  public closeConfirmPopup(confirmed: boolean) {
    this.showConfirmPopup = false;

    if (confirmed) {
      this.confirmPopupJobTypeSelector.selected = true;
      this.selectJobTypes();
    }
  }

  public openConfirmPopup(jobTypeSelector: JobTypeSelector) {
    this.confirmPopupJobTypeSelector = jobTypeSelector;
    this.confirmPopupContent = this.languageService.getString(jobTypeSelector.jobType.confirmPopupKey);
    this.showConfirmPopup = true;
  }

  constructor(
    public _metaDataService: MetaDataService,
    _router: Router,
    _activatedRoute: ActivatedRoute,
    _jobDataService: JobDataService,
    _toastr: ToastrService,
    _db: AngularFirestore,
    _clients: Clients,
    _questionTypes: QuestionTypes,
    public postcodeManager: PostcodeManagerService,
    public tradeTypes: TradeTypes,
    private _routerService: RouterService,
    public languageService: LanguageService) {

    this.router = _router;
    this.route = _activatedRoute;
    this.toastr = _toastr;
    this.db = _db;
    this.clients = _clients;
    this.questionTypes = _questionTypes;

    this.metaData = _metaDataService;
    this.jobDataService = _jobDataService;

    this.clientID = environment.clientID;
    this.metaData.currentTriageQuestion = null;
  }

  ngOnInit() {
    if ((<any>window).skipToHome == true) {
      (<any>window).skipToHome = false;
      this.router.navigate(['/home']);
      return;
    }

    var component = this;

    if (this.metaData.metaDataLoaded == false) {
      this.metaDataLoading = true;

      this.metaData.loadMetaData().then(function() {
        component.setupScreen();
        component.metaDataLoading = false;
      });
    } else {
      component.setupScreen();
    }

    window.scrollTo(0, 0);

  } // ngOnInit

  public setupScreen() {
    this.url = this.router.url;

    this.route.queryParams // get querystring params
      .subscribe(params => {
        var tradeType = params.trade;
        this.postcode = params.postcode;

        if (this.postcode == null) {
          this.postcode = '';
        }

        this.metaData.tradeTypes.forEach(element => {
          if (element.urlID.toLowerCase() == tradeType.toLowerCase()) {
            this.trade = element;
            this.jobDataService.trade = this.trade;
          }
        });
      });

    if (this.trade == null) {
      this.router.navigate(['/home']);
    }

    this.jobTypeSelectors.length = 0;

    this.trade.jobTypes.forEach(jt => {
      this.jobTypeSelectors.push(new JobTypeSelector(jt));
    });

    if (this.postcode.length > 0) {
      this.metaData.checkPostcode(this.postcode, this.jobDataService.trade.id);
      this.jobDataService.postcode = this.postcode;
    }

    if (this.metaData.postcodeCheck == true) {
      if (this.trade.jobTypes.length == 1) {
        this.jobTypeSelectors[0].selected = true;
        this.selectJobTypes();
        //this.jobTypeClick(this.trade.jobTypes[0]);
      }
    }

    this.showPostcodeCheck = !this.metaData.postcodeCheck;
    this.showServicesList = this.metaData.postcodeCheck;

    this.metaData.pushAAStartTrade(this.jobDataService.trade.name);

    if (this.jobDataService.capability.hasMemberShip == true && this.showPostcodeCheck == false && this.jobDataService.memberQuestionAnswered == false) {
      this.showMemberShipCheck = true;
      this.showServicesList = false;
    } 
  }

  public toggleEmergencyPopup(show: boolean) {
    this.showEmergencyPopup = show;
  }

  public onNavigate(string: any) {
    // your logic here.... like set the url 
    const url = string;
    window.open(url, '_self');
  }

  public checkPostcode() {
    this.showPostcodeCheck = false;

    if (this.postcode.length > 0) {
      for (let group of this.postcodeManager.PostcodeGroups) {
        for (let p of group.Postcodes) {
          if (p == this.postcode) {
            this.postcodeManager.SelectedPostcodeGroup = group;
          }
        }
      }

      this.metaData.checkPostcode(this.postcode, this.jobDataService.trade.id);
      this.jobDataService.postcode = this.postcode;
    }

    if (this.metaData.postcodeCheck) {
      // 20190625 - DM - check for any intermediate steps
      if (this.jobDataService.capability.hasMemberShip) {
        this.showMemberShipCheck = true;
      } else {
        this.showServicesList = true;

        this.checkSkipServicesList();
      }

      this.metaData.pushAADataLayerPageView(this.postcode);

    } else {
      this.showAreaNotCovered = true;
    }
  } // checkPostcode

  public convertURLName(name: string): string {
    var newName = name.split(' ').join('-');
    newName = newName.split('_').join('-');

    return newName.toLowerCase();
  }

  // this may need to handle different question types in future, keeping it simple for now
  public setMemberShipAnswer(isMember: boolean): void {
    this.jobDataService.capability.memberShipConfig.answer = isMember;
    this.showMemberShipCheck = false;
    this.showServicesList = true;

    this.jobDataService.memberQuestionAnswered = true;
    this.metaData.pushAAIsMemberSelected(isMember);

    this.checkSkipServicesList();
  }

  public checkSkipServicesList(): void {
    if (this.metaData.postcodeCheck == true) {
      if (this.trade.jobTypes.length == 1) {
        this.jobTypeSelectors[0].selected = true;
        this.selectJobTypes();
        //this.jobTypeClick(this.trade.jobTypes[0]);
      }
    }
  }

  public jobTypeClick(jts: JobTypeSelector) {
    if (jts.jobType.emergency) {
      if (environment.emergencyEnabled == true) {
        this.router.navigate(['/emergency'], { queryParams: { postcode: this.postcode } });
      } else {
        this.toggleEmergencyPopup(true);
      }
    } else if (jts.jobType.redirectTrade != null && jts.jobType.redirectTrade.length > 0) {
      var queryParamsObject = this._routerService.GetStartRouteParams(jts.jobType.redirectTrade);
      this.router.routeReuseStrategy.shouldReuseRoute = function() { return false; };
      this.router.navigate(['/start'], { queryParams: queryParamsObject });
    } else if (jts.jobType.confirmPopupKey != null && jts.jobType.confirmPopupKey.length > 0) {
      this.openConfirmPopup(jts);
    } else {
      if (jts.selected) {
        jts.selected = false;
      } else {
        jts.selected = true;

        if (this.bundlingEnabled == false) {
          this.selectJobTypes();
        }
      }
    }
  } // jobTypeClick

  public selectJobTypes() {
    this.jobDataService.jobTypes.length = 0;

    var route: string = 'triage';
    var jobTypeIndex: number = 0;

    this.jobTypeSelectors.forEach(jt => {
      if (jt.selected) {
        if (jt.jobType.route == 'taps') {
          route = jt.jobType.route;
        } else {
          jt.jobType.jobTypeIndex = jobTypeIndex;
          this.jobDataService.jobTypes.push(jt.jobType);
        }
      }

      jobTypeIndex += 1;
    });

    if (this.jobDataService.jobTypes.length == 0 && route != 'taps') {
      return; // todo: handle error
    }

    var firstJobType: JobType = this.jobDataService.jobTypes[0];

    if (environment.GATrackingID.length > 0) {
      if (route != 'triage') {
        this.router.navigate(['/' + route]);
      } else {
        if (firstJobType.questions.length > 0) {
          this.router.navigate(['/triage'], { queryParams: { jobType: firstJobType.productCode, stepType: firstJobType.questions[0].questionTypeID } });
        } else {
          this.router.navigate(['/' + route]);
        }
      }
    } else {
      this.router.navigate(['/' + route]);
    }

  } // selectJobTypes

}

export class JobTypeSelector {
  public jobType: JobType = null;
  public selected: boolean = false;

  constructor(_jobType: JobType) {
    this.jobType = _jobType;
  }
}